import React, { useContext } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../contexts/AppContext';
import ActiveControl from '../../../components/ActiveControl';
import useVehicleService from '../../../app/services/hooks/useVehicleService';

interface Props {
    vehicleId: number;
    checkValue: boolean;
    callbackSuccess: () => void;
}

const VehicleSwitchChange = ({ vehicleId, checkValue, callbackSuccess }: Props) => {
    const { showLoading, hideLoading } = useContext(AppContext);
    const [checked, setChecked] = React.useState<boolean>(checkValue);
    const { activeVehicle } = useVehicleService();

    const active = (value: boolean) => {
        setChecked(value);

        activeVehicle(vehicleId, value, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });

                callbackSuccess();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setChecked(!value);
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };

    return <ActiveControl status={checked} id={vehicleId} callback={active} />;
};

export default VehicleSwitchChange;
